import { render, staticRenderFns } from "./SignaturePlaceholder.vue?vue&type=template&id=71ee392a"
import script from "./SignaturePlaceholder.vue?vue&type=script&lang=js"
export * from "./SignaturePlaceholder.vue?vue&type=script&lang=js"
import style0 from "./SignaturePlaceholder.vue?vue&type=style&index=0&id=71ee392a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports